// Display-name roster. Stands in for the legacy ServerNotifyExtensionInfo (202) roster,
// which the command-set-lock keeps in Phase-1 scope but whose event isn't in the mirrored
// contract yet. Replace with the live roster feed when it lands.
export const extensionRoster: Record<string, string> = {
  '1040': 'Reception', '1041': 'J. Alvarez', '1042': 'You', '1043': 'M. Chen',
  '1044': 'Billing', '1045': 'K. Park', '1046': 'T. Boone', '1047': 'Sales',
  '1048': 'D. Okafor', '1049': 'Support'
}
export const displayName = (ext: string): string => extensionRoster[ext] ?? ext

// DND display stub — which extensions are in Do-Not-Disturb. Stands in for the legacy
// ExtIsInDND (208) state until that event is added to the contract mirror. Idle + DND
// paints the tile amber (legacy DNDBackColor).
export const dndExtensions = new Set<string>(['1040'])
export const isDnd = (ext: string): boolean => dndExtensions.has(ext)

// Contacts directory — a mix of internal extensions (presence dot) and external numbers
// (no presence). Demo data; the real Contacts feature (Google sync) is a later port.
export interface Contact { name: string; ext?: string; number?: string }
export const contacts: Contact[] = [
  ...Object.entries(extensionRoster).map(([ext, name]) => ({ name, ext })),
  { name: 'Acme Supply (AP)', number: '+18005551234' },
  { name: 'Dr. Lin — referral', number: '+14805550182' },
  { name: 'FedEx pickup', number: '+18004633339' },
  { name: 'City Permits desk', number: '+16025557700' }
]
